import asModal from '../../../components/as-modal';

import { CustomersCreateLabelModal } from './index';

export const CreateLabelContentModal = asModal(CustomersCreateLabelModal);
